import React from 'react';
import GenericBoard from '../../shared/GenericBoard';
import { BoardName } from '../../../constants/BoardNames';
import { getStyle } from '../../../styles/styles';

const style = getStyle();

const PickAndPackBoardScreen = () => {
    return <>
        <h3 className="uk-heading-divider" style={style.titleStyle}>Pick and Pack Board</h3>
        <GenericBoard board={BoardName.PickAndPackBoard}
            mainTitle={"Pick and Pack Orders"}
            isShowTitle={true} />
    </>
}

export default PickAndPackBoardScreen;